<script>
import DidoDataset from "./components/Dataset.vue";

export default {
  name: "DidoDatasetCe",
  components: {
    DidoDataset,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoDatasetId: { type: String, required: true },
  },
  emits: [
    "dataset-retrieved",
    "dataset-not-retrieved",
    "label-selection",
    "datafile-selection",
    "bad-configuration",
  ],
  template: `
    <DidoDataset
      :api-url="didoUrl"
      :dataset-id="didoDatasetId"
      @dataset-retrieved="$emit('dataset-retrieved', $event)"
      @dataset-not-retrieved="$emit('dataset-not-retrieved', $event)"
      @label-selection="$emit('label-selection', $event)"
      @datafile-selection="$emit('datafile-selection', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
